import React from "react";
import Layout from "components/layout";
import ForgotPassword from "components/userAccount/forgot-password";

function index() {
  return (
    <Layout>
      <ForgotPassword/>
    </Layout>
  );
}

export default index;
